















































































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator';
import NavTabs, {
  NavTabInfo,
} from '@/components/we-coupons/nav-tabs/index.vue';
import { ViewType } from '@/components/we-coupons/view-switch-btn/business';
import {
  CouponClass,
  ViewLoadState,
  MerchantInfoWithAd,
  ReceivedCouponListType,
} from '@/types/we-coupons';
import to from '@/business/to.js';
import {
  getCouponClassList,
  getNextCouponClass,
  addClassItem,
  removeClassItem,
} from '@/business/we-coupons/coupon-class';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from '@/components/we-coupons/content-loader.vue';
import BounceContainer from '@/components/we-coupons/bounce-container.vue';
import ContentLoadFail from '@/components/we-coupons/content-load-fail/index.vue';
import { i18n } from '@/i18n';
import { elk, url } from '@tencent/ppd-base-libs';
import {
  setScrollTop,
  disableBounceScroll,
  hideMenuCopyUrl,
  initShare,
  dataLoadCompleteHelper,
} from './utils/view-helper';
import WxSubscribeDialog from '@/components/we-coupons/subscribe/wx-subscribe-dialog.vue';
import {
  handleGetCouponAction,
  HandleSubScribeRes,
  NotifyActionRet,
} from '@/business/we-coupons/coupon-subscribe';
import MerchantDialog from '@/components/we-coupons/merchant-dialog.vue';
import FavoritesTab from '@/components/we-coupons/favorites-tab/index.vue';
import { getMyFavoritesSpList } from '@/components/my-favorites/api';
import { favoritesStore } from '@/business/favorites-store';
import { HelpFriend } from '@tencent/wphk-components-help-friend';
import ShareDialog from '@tencent/wphk-components-wecoupon/components/share-channel/share-dialog.vue';
import NormalThemeHeader from '@/components/we-coupons/theme/normal-header.vue';
import ThemeCom from '@tencent/wphk-components-wecoupon/components/theme/index.vue';
import SwitchBtnCom from '@/components/we-coupons/switch-btn/index.vue';
import SearchBoxCom from '@/components/search/search-box.vue';
import { clearKeyStorage } from '@/business/we-coupons/coupon-search';

import { NS } from '@/components/my-favorites/types';
import { allSettled } from '@/util/index';
import { saveFirstVisitWecoupons } from '@/business/home-newest';
import { ERouteName } from '@/config';
import UseGuide from '@tencent/wphk-components-wecoupon/components/guide/index.vue';
import { getAdClassIdFromUrl } from '@/business/home';

@Component({
  components: {
    NavTabs,
    BaseComponent,
    ContentLoader,
    ContentLoadFail,
    BounceContainer,
    WxSubscribeDialog,
    MerchantDialog,
    FavoritesTab,
    HelpFriend,
    ShareDialog,
    NormalThemeHeader,
    ThemeCom,
    SwitchBtnCom,
    SearchBoxCom,
    UseGuide,
  },
})
/**
 * 抢券有So，券列表展示页面
 */
export default class WeCouponsIndexView extends Vue {
  /** 商户券列表半弹窗 */
  @Ref('dialog') merchantDialog!: MerchantDialog;
  @Ref('navContent') navContentEl!: BaseComponent;
  @Ref('mainContent') mainContentEl!: HTMLElement;
  @Ref('navtabs') navTabs!: NavTabs;
  /** 订阅弹窗 */
  @Ref('wxSubscribeDialog') wxSubscribeDialog!: WxSubscribeDialog;
  /** 助力弹窗 */
  @Ref('helpFriendDialog') helpFriendDialog;
  @Ref('indexHeader') indexHeaderElm!: HTMLElement;
  @Ref('topNavBar') topNavBarElm!: HTMLElement;

  favoritesStore = favoritesStore;
  NS = NS;

  /** 订阅模板 id */
  unSubscribeTmpIds: string[] = [];
  /** 订阅弹窗提示内容 */
  subscribeTipContent = '';

  /**
   *  视图类型
   */
  viewType = ViewType.couponList;

  /**
   * 分类列表
   */
  tabClassList: CouponClass[] = [];

  /**
   * 当前分类ID
   */
  classId = '';

  /**
   * 页面加载状态
   */
  loadState = ViewLoadState.Loading;

  /**
   * 导航栏距离顶部位置
   */
  navScrollTop = 0;

  /**
   * 子路由列表数据是否加载完毕
   */
  isDataLoadCompleted = false;

  /** 已领取的优惠券id */
  receivedCouponIdList: ReceivedCouponListType = [];

  isHeaderReady = false;
  /** 是否有展示专题 */
  isShowThemeCom = false;
  /** 分类-收藏的数据项，动态添加到this.tabClassList或移除 */
  favoritesItem = {
    classId: NS.Favorites as string,
    className: i18n('收藏') as string,
  };

  headerHeight = 0;

  /** 头部主题组件，已删除春节头部主题组件 */
  get themeHeader() {
    return 'NormalThemeHeader';
  };
  /** 不同头部主题组件所对应的样式，跟this.themeHeader一一对应 */
  get wecouponTheme() {
    return 'wecoupons-index_normal';
  }

  /**
   * 视图状态
   */
  get viewState() {
    return {
      // 数据加载完毕标示
      isReady: this.loadState !== ViewLoadState.Loading,
      // 数据初始化失败
      isError: this.loadState === ViewLoadState.Error,
      // 是否有数据加载
      hasData:
        this.loadState !== ViewLoadState.Loading && this.navTabsData.length > 0,
    };
  }

  /**
   * 计算分类列表数据
   */
  get navTabsData(): NavTabInfo[] {
    return this.tabClassList.map(item => ({
      name: item.className,
      id: item.classId,
      actived: item.classId === this.classId, // 当前classId所对应的分类高亮
    }));
  }

  /**
   * 是否启用弹跳效果
   * 只有当前分类数据加载完毕，并且还有下一分类时才启用弹跳效果
   */
  get isEnableBounce() {
    return this.isDataLoadCompleted && !!getNextCouponClass(this.classId);
  }

  @Watch('favoritesStore.hasChange')
  favoritesChange() {
    this.updateFavoritesTab();
  }

  @Watch('viewState.isReady')
  onviewStateReady() {
    document.body.style.overflowY = 'auto';
    this.$nextTick(() => {
      this.initScrollTop();
      this.handleTabScrollForAd();
    });
  }
  /**
   * 呈现当前分类列表信息
   */
  @Watch('viewType')
  onviewTypeChanged() {
    this.renderChildView();
  }
  /**
   * 设置当前分类ID
   */
  @Watch('classId')
  onClassIdChanged(newVal, oldVal) {
    this.renderChildView();
    // 初次访问不要设置
    if (!oldVal) return;
    setTimeout(() => {
      if (this.headerHeight) {
        let scrollHeight = this.headerHeight;
        const topNavBarElmRect = this.topNavBarElm.getBoundingClientRect();
        scrollHeight = scrollHeight + this.indexHeaderElm.offsetTop - topNavBarElmRect.height;
        // @ts-ignore
        document.getElementById('app').scrollTo(0, scrollHeight);
      }
    }, 300);
  }

  /**
   * 新增外部banner跳转tab锚点：当跳转链接上带有adClassId时且当前classid为指定classid时，跳转到对应的tab并吸顶，链接如下：
   * https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml?adClassId=class11&page=home/couponList/class11
   */
  handleTabScrollForAd() {
    const isAd = getAdClassIdFromUrl() === this.classId;
    if (this.topNavBarElm && isAd) {
      this.topNavBarElm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /**
   * 保存navTab可滚动距离，便于后续切换分类时能保持分类栏的位置
   */
  initScrollTop() {
    if (this.navContentEl) {
      setScrollTop(0);
      this.navScrollTop = this.navContentEl.$el.getBoundingClientRect().top;
    }
  }

  /**
   * 保持顶部导航栏位置不变
   */
  holdScrollTop() {
    const el = this.mainContentEl;
    if (el) {
      const scrollTop = document.getElementById('app')?.scrollTop
        || document.documentElement.scrollTop
        || document.body.scrollTop;
      // 给页面定一个最小高度，目的是撑起页面，确保页面能固定导航栏位置
      el.style.minHeight = `${window.innerHeight - Math.max(el.getBoundingClientRect().top, 0)}px`;
      // 设置并固定导航栏位置
      setTimeout(() => {
        setScrollTop(Math.min(this.navScrollTop + 1, scrollTop));
      });
    }
  }

  /**
   * 渲染子路由视图
   */
  renderChildView() {
    const classId = this.classId || (this.$route.params.classId as string) || '';
    let name = '';
    name = ERouteName.homeWeCouponsList;
    this.holdScrollTop();
    this.isDataLoadCompleted = false;
    this.$router.replace({
      name,
      params: { name, classId: classId.toString() },
    });
  }

  /**
   * 处理视图类型变化
   */
  handleViewTypeChanged(type: ViewType) {
    this.viewType = type;
  }

  /**
   * 分类导航切换
   */
  handleNavTabsChanged(data: NavTabInfo) {
    this.classId = data.id as string;
    favoritesStore.isFavoritesTab = this.classId === NS.Favorites;
    console.log('current tab ID:', this.classId);
  }

  /**
   * 刷新页面
   */
  handleRefresh() {
    window.location.reload();
  }

  /**
   * 弹跳上拉回弹后切换到下一个分类
   */
  handleBounceScrollEnd() {
    const couponClass = getNextCouponClass(this.classId);
    if (couponClass) {
      this.navTabs.switchTab(couponClass.classId);
    }
  }

  /**
   * 设置视图状态
   */
  setViewState(state: ViewLoadState) {
    setTimeout(() => {
      this.loadState = state;
    }, 300);
  }

  /**
   * 展示商户下券列表半弹层
   */
  showMerchantDialog(item: MerchantInfoWithAd) {
    // 打开弹窗
    this.merchantDialog?.showDialog(item);
  }
  /**
   * 展示好友助力弹窗
   */
  showHelpFriendDialog(couponId: string) {
    this.helpFriendDialog.showHelpFriendDialog(couponId);
  }

  /**
   * 初始化页面数据
   */
  async initData() {
    const [classRes, favRes] = await allSettled([getCouponClassList(), getMyFavoritesSpList(0, 1)]);
    if (classRes.status === 'fulfilled') {
      this.setViewState(ViewLoadState.Success);
    } else {
      this.setViewState(ViewLoadState.Error);
      return;
    }
    this.classId = (this.$route.params.classId as string) || ((classRes.value || [])[0] as CouponClass)?.classId;
    if (favRes && favRes.status === 'fulfilled' && favRes.value.totalCount > 0) {
      this.tabClassList = [this.favoritesItem].concat(classRes.value as CouponClass[]);
      addClassItem(this.favoritesItem);
    } else {
      this.tabClassList = classRes.value as CouponClass[];
    }
  }

  /**
   * 动态更新收藏TAB项
   */
  async updateFavoritesTab() {
    const [err, res] = await to(getMyFavoritesSpList(0, 1));
    if (err) return;
    const favoritesTab = this.tabClassList.find(item => item.classId === NS.Favorites);
    if (res?.totalCount > 0 && !favoritesTab) { // 有收藏商户但是没有收藏tab项
      this.tabClassList = [this.favoritesItem].concat(this.tabClassList);
      addClassItem(this.favoritesItem);
    } else if (res?.totalCount === 0 && favoritesTab) { // 没有收藏商户但是有收藏tab项
      this.tabClassList = this.tabClassList.filter(item => item.classId !== NS.Favorites).concat();
      removeClassItem(this.favoritesItem);
    }
  }

  async created() {
    document.body.style.overflowY = 'hidden';
    setScrollTop(0);
    saveFirstVisitWecoupons(); // 移到上面，避免下面流程中出错就再也无法进入优惠区了
    await this.initData();
    // 禁止页面底部copy URL按钮
    hideMenuCopyUrl();
    // 禁止webview页面弹跳
    disableBounceScroll();
    // 监听子路由页面数据加载完毕通知
    dataLoadCompleteHelper.listen(this, () => {
      this.isDataLoadCompleted = true;
    });
    // 分享初始化
    initShare();

    // 避免theme组件出问题，如果超时2s没抛事件就展示
    setTimeout(() => {
      this.isHeaderReady = true;
    }, 2000);
    elk({ key: 'wecoupon_pv_uv_report' });
  }

  /**
   * 显示订阅弹窗
   */
  async showSubscribeDialog(result: NotifyActionRet) {
    // 处理领券接口
    const isShowSubscribeDialog = await handleGetCouponAction(result, (unSubscribeTmpIds, subscribeTipContent) => {
      this.unSubscribeTmpIds = unSubscribeTmpIds || [];
      this.subscribeTipContent = subscribeTipContent || '';
      (this.$refs.wxSubscribeDialog as WxSubscribeDialog)?.showDialog();
    });
    /** 如果是订阅弹窗不展示（展示过了）就播放教程动画
     * 订阅弹窗要展示的话已经在上面的handleGetCouponAction第二个参数回调函数处理了
     */
    if (isShowSubscribeDialog === HandleSubScribeRes.hideSubscribeDialog) {
      this.playUserGuideAnimation();
    }
    // 在券列表中领取时，也要通知外部
    this.updateReceivedList(result);
  }

  /**
   * 成功领取优惠券
   * @param receivedCouponIdList
   */
  onAdGetCoupon(receivedCouponIdList: ReceivedCouponListType) {
    const arr = this.receivedCouponIdList.concat(receivedCouponIdList);
    // 对象数组去重
    const map = new Map();
    for (const item of arr) {
      if (!map.has(item.couponId)) {
        map.set(item.couponId, item);
      }
    }
    this.receivedCouponIdList = [...map.values()];
  }

  /**
   * 重置微信分享
   */
  resetWxShare() {
    initShare();
  }

  // 处理theme组件的事件
  handleThemeAction({ name, data }: NotifyActionRet) {
    // 是否有展示
    if (name === 'initDone') {
      console.log('initDone', data);
      const { isShow = false } = data as any;
      this.isShowThemeCom = isShow;
      this.isHeaderReady = true;
      return;
    }

    if (name === 'getCoupon') {
      this.handleCouponReceive({ name, data });
      return;
    }
  }
  // 处理专题组件领券后同步状态到券列表
  handleCouponReceive({ name, data }: NotifyActionRet) {
    console.log('handleCouponReceive', name, data);
    if (name === 'getCoupon' && data?.result) {
      this.showSubscribeDialog({ name, data });
      this.updateReceivedList({ name, data });
    }
  }


  // 处理专题组件的券状态，在券列表中领取时，也往以领取列表中塞
  updateReceivedList(result: NotifyActionRet) {
    // 处理领券时同步状态问题
    const data = result?.data?.result;
    if (data) {
      const param: ReceivedCouponListType = [
        {
          userScid: data.userScid as string,
          couponId: data.couponId as string,
        },
      ];
      this.onAdGetCoupon(param);
    }
  }

  goSearch() {
    clearKeyStorage();
    this.$router.push({
      name: ERouteName.couponsSearch,
    });
  }

  @Watch('isHeaderReady')
  handleHeader(val) {
    if (val) {
      this.$nextTick(() => {
        this.headerHeight = this.indexHeaderElm.getBoundingClientRect().height;
      });
    }
  }

  playUserGuideAnimation() {
    (this.$refs.useGuide as any).playAnimation();
  }
  onHideSubscribeDialog() {
    this.playUserGuideAnimation();
  }
}
